// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DraggableWidgetList {\n  padding: 30px 35px 10px 35px;\n  box-sizing: border-box;\n  min-height: 100%; }\n  .DraggableWidgetList_Widget {\n    padding: 10px 10px 10px 25px;\n    cursor: move; }\n    .DraggableWidgetList_Widget .WrapperWidget {\n      margin-bottom: 0;\n      padding-right: 0; }\n", ""]);
// Exports
module.exports = exports;
